import { Link } from "@tanstack/react-router";

export function TelehealthCta() {
  return (
    <div className="mt-6 text-center">
      <Link
        to="/appointments"
        preload="intent"
        className="inline-block max-w-full rounded-full bg-primary px-7 py-3 text-sm font-medium leading-snug text-primary-foreground hover:opacity-90"
      >
        Far Away? Make a Telehealth Appointment
      </Link>
    </div>
  );
}
